import { render, staticRenderFns } from "./PublishUnpublish.vue?vue&type=template&id=59c5ff48"
import script from "./PublishUnpublish.vue?vue&type=script&lang=js"
export * from "./PublishUnpublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports